module.exports = __webpack_public_path__ + "static/media/pt.2f33a7e7.svg";